import { Link, useNavigate } from "@tanstack/react-router";
import { ArrowRightIcon, PlusIcon, XIcon } from "lucide-react";
import { Button } from "../../ui/button/button";
import SuccessScreen from "@/components/ui/SuccessScreen";
import Typography from "@/components/ui/typography";
import { currencyFormatter } from "@/lib/utils";
import { centsToDollars } from "@/lib/number-conversion/number-conversion.utils";
import { SafeParseReturnType } from "zod";
import { TransferInResponse } from "@/api/transactions";

type Props = {
	transferResponse: SafeParseReturnType<unknown, TransferInResponse>;
};
const DepositSuccessPage: React.FC<Props> = ({ transferResponse }) => {
	const navigate = useNavigate();

	return (
		<div className="relative flex flex-col items-center  bg-white text-textDark h-[100dvh] justify-between text-center">
			<SuccessScreen
				title={"Your transfer is on the way"}
				description={
					<div>
						<div>
							<Typography variant={"p"}>
								Your funds are on the way and typically arrive within 48-72
								hours. We've sent you an email with all the details.
							</Typography>
						</div>
						<div className="mt-6">
							{transferResponse.success && (
								<div className="space-y-2">
									<div className="text-4xl font-bold text-textDark">
										+{" "}
										{currencyFormatter.format(
											centsToDollars(transferResponse.data.base_amount),
										)}
									</div>
									<Typography variant={"p"} color={"primary"}>
										Transaction #{transferResponse.data.transaction_no}
									</Typography>
								</div>
							)}
						</div>
					</div>
				}
			>
				<div className="space-y-2">
					<Button
						className="w-full text-base font-bold text-white"
						onClick={() => navigate({ to: "/main/deposit" })}
					>
						<PlusIcon className="w-5 h-5" />
						Convert more credit
					</Button>
					<Button
						onClick={() =>
							navigate({
								to: "/main/home",
							})
						}
						className="w-full "
						variant="secondary"
					>
						Back to Home
						<ArrowRightIcon className="w-5 h-5" />
					</Button>
				</div>
			</SuccessScreen>
			<Link to="/main/home">
				<XIcon className="absolute right-0 -top-2" role="button" />
			</Link>
		</div>
	);
};

export default DepositSuccessPage;
